var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showErrorPage)?_c('app-page-error'):_c('div',{style:(_vm.projectBackgroundStyle),attrs:{"id":"projectContainer"}},[_c('project-view-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }